import './style.scss';
import register from 'ShopUiBundle/modules/app/registry';

// tslint:disable-next-line
register('text-input', () => import(/* webpackMode: "lazy" */'./text-input'));
